export default __webpack_public_path__ + "static/media/real_time_people.ce34a2f7.svg";